(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var openBtn = document.getElementById('mobileOpen');
    var closeBtn = document.getElementById('mobileClose');
    var overlay = document.getElementById('mobileOverlay');

    function openMobile() {
      if (!overlay) return;
      overlay.classList.add('open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeMobile() {
      if (!overlay) return;
      overlay.classList.remove('open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    // Sticky header: add a shadow once the page has scrolled past the top.
    var header = document.getElementById('siteHeader');
    if (header) {
      var toggleScrolled = function () {
        header.classList.toggle('is-scrolled', window.scrollY > 4);
      };
      toggleScrolled();
      window.addEventListener('scroll', toggleScrolled, { passive: true });
    }

    if (openBtn) openBtn.addEventListener('click', openMobile);
    if (closeBtn) closeBtn.addEventListener('click', closeMobile);
    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closeMobile();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMobile();
    });

    // Scroll-reveal
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('in');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );
      document
        .querySelectorAll('.simple-card, .detail-card, .dark-feature, .process-card, .solution-mini')
        .forEach(function (el) {
          el.classList.add('reveal');
          io.observe(el);
        });
    }

    // If the contact form posted successfully, scroll the success panel into view.
    var successBox = document.querySelector('.success-box');
    if (successBox) {
      successBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    var formErrors = document.querySelector('.form-error-box');
    if (formErrors) {
      formErrors.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    // Checkbox-list "dropdown" multi-select (works via tap, no Ctrl/Cmd needed).
    // Checkboxes are UI-only; a single hidden field submits the joined value,
    // since Shopify's contact form rejects array-style field names as invalid.
    var multiselects = document.querySelectorAll('[data-multiselect]');
    multiselects.forEach(function (root) {
      var fieldEl = root.closest('.field') || root.parentElement;
      var trigger = root.querySelector('[data-multiselect-trigger]');
      var panel = root.querySelector('[data-multiselect-panel]');
      var hiddenField = root.querySelector('[data-multiselect-hidden]');
      var selectedText = fieldEl.querySelector('[data-multiselect-selected]');
      var errorHint = fieldEl.querySelector('[data-multiselect-error]');
      var inputs = root.querySelectorAll('[data-multiselect-input]');
      if (!trigger || !panel || !inputs.length) return;

      root.classList.add('is-enhanced');
      panel.style.display = 'none';

      function checkedInputs() {
        return Array.prototype.filter.call(inputs, function (input) {
          return input.checked;
        });
      }

      function updateSelectedText() {
        var checked = checkedInputs();
        var names = checked.map(function (input) {
          return input.value;
        });

        if (hiddenField) {
          hiddenField.value = names.join(', ');
        }

        if (!selectedText) return;
        if (!names.length) {
          selectedText.hidden = true;
          selectedText.innerHTML = '';
          return;
        }
        selectedText.innerHTML = '<strong>Selected:</strong> ' + names.join(', ');
        selectedText.hidden = false;
        if (errorHint) {
          errorHint.hidden = true;
          errorHint.classList.remove('is-error');
        }
      }

      function openPanel() {
        panel.style.display = '';
        trigger.setAttribute('aria-expanded', 'true');
        root.classList.add('is-open');
      }
      function closePanel() {
        panel.style.display = 'none';
        trigger.setAttribute('aria-expanded', 'false');
        root.classList.remove('is-open');
      }

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        if (panel.style.display === 'none') openPanel();
        else closePanel();
      });
      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) closePanel();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closePanel();
      });
      inputs.forEach(function (input) {
        input.addEventListener('change', updateSelectedText);
      });

      var form = root.closest('form');
      if (form) {
        form.addEventListener('submit', function (e) {
          if (!checkedInputs().length) {
            e.preventDefault();
            openPanel();
            if (errorHint) {
              errorHint.hidden = false;
              errorHint.classList.add('is-error');
            }
            trigger.focus();
          }
        });
      }

      updateSelectedText();
    });
  });
})();
